// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7966) return "static/css/7966.43eb720282bde004983a.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "83971b4df2c901ec0bdb" + ".chunk.css";
};